import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import PlatformBox from "../platform-box";
import WhiteExes from "../../assets/icons/white-exes-animated.gif";
import StaticCover from "../../assets/images/static-cover.gif";
import ContestIcons from "../../assets/icons/bzrp-cont-icons.png";
import BzrpMainImg from "../../assets/images/biza-main-img.gif";
import sagasMainImg from "../../assets/images/sagas-section-img.gif";

const sxStyles = {
  mainContainer: {
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    height: { xs: "750px", md: "600px" },
  },
  staticCover: {
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    height: { xs: "750px", md: "600px" },
    width: { xs: "375px", md: "1440px", xl: "1920px" },
    alignItems: "center",
    paddingLeft: { xs: 0, md: 0, xl: "250px" },
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    height: "100%",
    backgroundRepeat: "no-repeat",
    paddingTop: { xs: "50px", md: "100px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "34px" },
    textAlign: "left",
    maxWidth: { xs: "355px", md: "100%" },
    paddingLeft: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "#FDD925",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "40px", md: "45px" },
    fontWeight: "700",
    lineHeight: { xs: "42px", md: "65px" },
    marginRight: "13px",
  },
  title: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "40px", md: "45px" },
    fontWeight: "400",
    lineHeight: { xs: "42px", md: "65px" },
    marginRight: "13px",
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const ContestSection = () => {
  return (
    <Grid sx={sxStyles.staticCover}>
      <Box
        sx={{
          height: { xs: "750px", md: "600px" },
          width: { xs: "375px", md: "1440px", xl: "1670px" },
          position: "absolute",
          backgroundImage: `url(${StaticCover})`,
          opacity: "15%",
          zIndex: "1",
        }}
      />
      <Grid sx={sxStyles.mainContainer}>
        <Grid sx={sxStyles.content}>
          <Box
            sx={{
              width: { xs: "300px", md: "600px" },
              height: { xs: "300px", md: "620px" },
              paddingTop: { xs: 0, md: "50px" },
              backgroundImage: {
                xs: `url(${BzrpMainImg})`,
                md: `url(${BzrpMainImg})`,
              },
              backgroundPosition: { xs: "left top", md: "center center" },
              backgroundSize: { xs: "cover", md: "cover" },
              position: { xs: "absolute", md: "relative" },
              top: { xs: "460px", md: "-50px", xl: "35px" },
              left: { xs: "40px", md: "unset" },
              right: { xs: 0, md: "unset" },
              zIndex: 1,
            }}
          />
          <Stack
            sx={{
              position: "relative",
              paddingTop: { xs: "", md: "30px" },
            }}
          >
            <Box
              sx={{
                height: "70px",
                display: "flex",
                backgroundImage: `url(${ContestIcons})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                width: { xs: "280px", md: "400px" },
                alignSelf: "center",
                marginRight: { xs: 0, md: "125px" },
              }}
            />
            <Stack
              sx={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "center",
                alignItems: "center",
                width: "800px",
              }}
            >
              <Grid
                sx={{
                  display: { xs: "none", md: "flex" },
                  marginTop: "20px",
                  justifyContent: { xs: "center", md: "left" },
                }}
              >
                <Typography sx={sxStyles.title}>GANÁ </Typography>
                <Typography sx={sxStyles.p2Title}>UN VIAJE </Typography>
                <Typography sx={sxStyles.title}>PARA VER A </Typography>
              </Grid>
              <Stack
                sx={{
                  display: { xs: "flex", md: "none" },
                  marginTop: "20px",
                  justifyContent: { xs: "center", md: "left" },
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    paddingLeft: "25px",
                  }}
                >
                  <Typography sx={sxStyles.title}>GANÁ </Typography>
                  <Typography sx={sxStyles.p2Title}>UN</Typography>
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={sxStyles.p2Title}>VIAJE </Typography>
                  <Box sx={{ display: { xs: "flex", md: "none" } }}>
                    <Typography sx={sxStyles.title}>PARA</Typography>
                  </Box>
                </Grid>
                <Box sx={{ display: { xs: "none", md: "flex" } }}>
                  <Typography sx={sxStyles.title}>PARA VER A </Typography>
                </Box>
              </Stack>
              <Stack
                sx={{
                  display: { xs: "flex", md: "none" },
                  justifyContent: { xs: "center", md: "left" },
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={sxStyles.title}>VER A </Typography>
                  <Typography sx={sxStyles.p2Title}>BZRP </Typography>
                  <Typography sx={sxStyles.title}>EN</Typography>
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    paddingLeft: "25px",
                  }}
                >
                  <Typography sx={sxStyles.title}>SU</Typography>
                  <Typography sx={sxStyles.title}>SHOW EN</Typography>
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "flex", md: "none", paddingLeft: "60px" },
                    }}
                  >
                    <Typography sx={sxStyles.p2Title}>MÉXICO!</Typography>
                  </Box>
                </Grid>
                <Box sx={{ display: { xs: "none", md: "flex" } }}>
                  <Typography sx={sxStyles.title}>PARA VER A </Typography>
                </Box>
              </Stack>
              <Grid
                sx={{
                  display: { xs: "none", md: "flex" },
                  marginTop: "20px",
                  justifyContent: { xs: "center", md: "left" },
                  marginBottom: "70px",
                }}
              >
                <Typography sx={sxStyles.p2Title}>BZRP </Typography>
                <Typography sx={sxStyles.title}>EN SU SHOW EN</Typography>
                <Typography sx={sxStyles.p2Title}>MÉXICO! </Typography>
              </Grid>
            </Stack>
            <Box
              sx={{
                paddingLeft: { xs: "12px", md: 0 },
                paddingRight: { xs: "10px", md: "140px" },
                display: "flex",
                paddingBottom: { xs: "20px", md: 0 },
                justifyContent: "center",
                marginTop: { xs: "20px", md: "" },
              }}
            >
              <PlatformBox />
            </Box>
            <Box
              sx={{
                width: "450px",
                height: "90px",
                position: "absolute",
                zIndex: 1,
                left: { xs: "10px", md: "-480px", xl: "-510px" },
                top: { xs: "75px", md: "250px", xl: "210px" },
                display: { xs: "none", md: "flex" },
              }}
            >
              <img
                src={WhiteExes}
                style={{ width: "450px", height: "80px" }}
                alt={""}
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ContestSection;
